import React from 'react';

type AuthorDescriptionProps = {
  children: string;
  classes?: string;
};

function AuthorDescription({ children, classes = '' }: AuthorDescriptionProps) {
  return <p className={classes}>{children}</p>;
}

export default AuthorDescription;
